<template>
  <div>
    <b-row class="px-2 py-2">
      <b-col sm="6" lg="6">
        <div class="d-flex align-items-center">
          <span class="mr-1">Mostrar</span>
          <v-select
              id="tableSize"
              v-model="paginationData.defaultSize"
              @input="updateQtdView"
              :options="table.optionsSize"
              :clearable="false"
              style="width: 87px;"
          >
            <span slot="no-options">Nenhuma opção selecionável.</span>
          </v-select>
        </div>
      </b-col>
    </b-row>

    <section class="list-carteira">
      <b-table
          :id="tableId"
          responsive
          :busy.sync="filtering"
          :fields="table.fields"
          :items="table.items"
          no-local-sorting
      >
        <template #cell(colaborador)="row">
          <span class="d-flex font-weight-bold comprimento_maximo_celulas" v-b-tooltip>
            {{ row.item.nome }}
          </span>
        </template>
        <template #cell(cpf)="row">
          <span class="font-weight-bold comprimento_maximo_celulas">
            {{ row.item.cpf | formataCpfCnpj }}
          </span>
        </template>
        <template #cell(acoes)="row">
          <div class="d-flex align-items-center">
            <div
                class="button-wrapper mr-1"
                v-b-tooltip.hover.bottom
                :title="row.item.possui_vacinacao ? 'Visualizar Carteira de Vacinação do colaborador' : 'Carteira indisponível. Colaborador sem registros de vacinação.'"
            >
              <button
                  id="view-vaccination-card"
                  class="button-icon text-custom-blue"
                  :class="{ disabled: !row.item.possui_vacinacao }"
                  :disabled="!row.item.possui_vacinacao"
                  @click.prevent="$emit('view-card', row.item)"
                  aria-label="Visualizar Carteira de Vacinação"
              >
                <feather-icon icon="EyeIcon" size="18"/>
              </button>
            </div>

            <div
                class="button-wrapper mr-1"
                v-b-tooltip.hover.bottom
                :title="row.item.possui_vacinacao ? 'Gerar Carteira de Vacinação em PDF' : 'Carteira indisponível. Colaborador sem registros de vacinação.'"
            >
              <button
                  v-if="!loadingVaccinationCard[row.item.cpf]"
                  id="download-vaccination-card"
                  class="button-icon text-custom-blue"
                  :class="{ disabled: !row.item.possui_vacinacao }"
                  :disabled="!row.item.possui_vacinacao"
                  @click.prevent="$emit('generate-card', row.item.cpf)"
                  aria-label="Gerar Carteira de Vacinação em PDF"
              >
                <feather-icon icon="DownloadIcon" size="18"/>
              </button>

              <b-spinner
                  v-else
                  small
                  variant="primary"
              />
            </div>

            <div
                class="button-wrapper mr-1"
                v-b-tooltip.hover.bottom
                :title="!codigoAcessoAtivo(row.item) ? 'Gerar código de acesso' : 'Este CPF já possui acesso ativo.'"
            >
              <button
                  id="gerar-codigo-acesso"
                  class="button-icon text-custom-blue"
                  :class="{ disabled: codigoAcessoAtivo(row.item) }"
                  :disabled="codigoAcessoAtivo(row.item)"
                  @click.prevent="$emit('generate-code', row.item)"
                  aria-label="Gerar código de acesso"
              >
                <feather-icon icon="KeyIcon" size="18"/>
              </button>
            </div>
          </div>
        </template>

      </b-table>
      <div class="pb-2 px-1">
        <span v-if="withoutResults" class="ml-1">CPF não encontrado ou sem registros de vacinação.</span>
        <b-col sm="12" class="mt-2" v-if="table.items.length > 0">
          <CustomPagination
              :paginacao="paginationData"
              @page-cliked="$emit('page-changed', $event)"
          />
        </b-col>
      </div>
    </section>
  </div>
</template>

<script>
import {BTable, BCol, BRow, BSpinner, VBTooltip} from "bootstrap-vue";
import vSelect from "vue-select";
import CustomPagination from "@/views/components/custom/pagination/CustomPagination.vue";

export default {
  name: "CarteiraVacinacaoTable",
  components: {
    BTable,
    BCol,
    BRow,
    BSpinner,
    CustomPagination,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  props: {
    tableId: {
      type: String,
      default: "tableCarteira"
    },
    filtering: {
      type: Boolean,
      default: false
    },
    table: {
      type: Object,
      required: true
    },
    paginationData: {
      type: Object,
      required: true
    },
    withoutResults: {
      type: Boolean,
      default: false
    },
    loadingVaccinationCard: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    updateQtdView() {
      this.$emit('update-qty', this.paginationData.defaultSize);
    },
    codigoAcessoAtivo(item) {
      return item.situacao_codigo_acesso === 'Ativado';
    }
  }
};
</script>

<style scoped>
.comprimento_maximo_celulas {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.button-wrapper.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.button-icon {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.button-icon:focus {
  outline: none;
}

.button-icon.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.tooltip {
  pointer-events: none;
}

</style>
